import * as React from "react";
import { observer } from "mobx-react";
import { Alert, Button, Alignment, FormGroup, Intent, NonIdealState, HTMLSelect, } from "@blueprintjs/core";
import { EmpresaSelect, filterEmpresa, renderEmpresa } from "../empresa/EmpresaSelect";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";
import { IEmpresa, newEmpresa } from "../../model";
import { SpedEfdStore } from "../../stores/sped/SpedEfdStore";
import { formatCnpj } from "../../utils";
import { toast } from "react-toastify";

interface ImportCfopsProps {
    isOpen: boolean
    onClose: () => void
}

@observer
export default class ImportCfops extends React.Component<ImportCfopsProps, {}>{

    constructor(props: ImportCfopsProps) {
        super(props);
    }

    async handleImportCfops() {
        if (SpedEfdStore.obs.selectedEmpresaImport.cnpj == "") {
            toast.warning('Você precisa selecionar uma Empresa.', {});
            return
        }

        if (SpedEfdStore.obs.modelo == "selecione") {
            toast.warning('Você precisa selecionar um Modelo.', {});
            return
        }

        let config_id = await SpedEfdStore.loadSpedImport(SpedEfdStore.obs.selectedEmpresaImport.cnpj, SpedEfdStore.obs.entrada_saida, SpedEfdStore.obs.modelo)
        if (config_id == "") {
            toast.error("Empresa sem Configurações.", {})
            return
        }

        await SpedEfdStore.loadCfopsImport(config_id)

        if (SpedEfdStore.obs.index_cfops_import.length == 0) {
            toast.error("Empresa não possui CFOPs Cadastrados, verifique e tente novamente.", {})
            return
        }

        SpedEfdStore.obs.index_cfops_import?.map(value => {
            delete value.id
            value.config_id = SpedEfdStore.obs.config_id
        })

        await SpedEfdStore.saveCfopsImport(SpedEfdStore.obs.index_cfops_import, SpedEfdStore.obs.entrada_saida)
        this.props.onClose()
    }

    render() {
        let empresaTextProg = SpedEfdStore.obs.selectedEmpresaImport.cnpj != ""
            ? `${SpedEfdStore.obs.selectedEmpresaImport.razao_social.substring(0, 38)}... (${formatCnpj(SpedEfdStore.obs.selectedEmpresaImport.cnpj)})`
            : "Selecione uma empresa";

        return (
            <>
                <Alert
                    cancelButtonText="Fechar"
                    confirmButtonText="Importar"
                    isOpen={this.props.isOpen}
                    onClose={() => this.props.onClose()}
                    onConfirm={() => this.handleImportCfops()}
                    className="AlertUser"
                    canOutsideClickCancel={true}
                    intent={Intent.PRIMARY}
                >
                    <h2 className="titleSEFAZ">Importar CFOPs</h2>
                    <p style={{ marginBottom: 35, marginTop: -30 }}><i>Selecione a Empresa da qual deseja copiar os CFOPs!</i></p>

                    <FormGroup
                        label="Empresa"
                        className="empresaSelect"
                    >
                        <EmpresaSelect
                            items={EmpresaStore.sortedEmpresas}
                            itemRenderer={renderEmpresa}
                            itemPredicate={filterEmpresa}
                            onItemSelect={(e: IEmpresa) => SpedEfdStore.obs.selectedEmpresaImport = e}
                            inputProps={{ placeholder: "Filtrar uma empresa" }}
                        >
                            <Button
                                text={empresaTextProg}
                                rightIcon="double-caret-vertical"
                                alignText={Alignment.LEFT}
                            />
                        </EmpresaSelect>
                    </FormGroup>

                    <FormGroup label="Modelo">
                        <HTMLSelect
                            onChange={(e) => SpedEfdStore.obs.modelo = e.target.value}
                            value={SpedEfdStore.obs.modelo}
                        >
                            <option value="selecione">Selecione</option>
                            <option value="nfe">NF-e</option>
                            <option value="cte">CT-e</option>
                            <option value="nfce">NFC-e</option>
                        </HTMLSelect>
                    </FormGroup>

                    <FormGroup label="Tipo">
                        <HTMLSelect
                            disabled
                            value={SpedEfdStore.obs.entrada_saida}
                        >
                            <option value="entrada">Entrada</option>
                            <option value="saida">Saída</option>
                        </HTMLSelect>
                    </FormGroup>

                    <p style={{ marginTop: 30 }}><i>Atenção! CFOPs com o mesmo Código serão sobrescritos pelo que estão sendo importados!</i></p>

                </Alert >
            </>
        );
    }

}